module.exports = __webpack_public_path__ + "img/ellis-logo.045b571f.jpg";